/**
 * Languages allowed in URLs (`/:lng/from/...`) and loaded in i18n.
 * Spanish uses ISO **`es`** (not `sp`). Chinese uses **`zh`** (Simplified UI copy).
 * **`he`** and **`ar`** use RTL (`dir`) — see `FirstRoute` in `First.jsx`.
 */
export const SUPPORTED_LNGS = ['en', 'de', 'fr', 'ru', 'it', 'es', 'he', 'zh', 'ja', 'ar'];
